<template>
  <div>
    <van-popup 
      v-model="isShowUnionpayPop" 
      round
      :close-on-click-overlay="false" 
      :style="{ width: '80%' }"
      get-container="body"
    >
      <div class="content-box">
        <div class="title">对账提示</div>
        <div class="text">
          因银联资金结算规则：<br />
          当日支付金额需在“第二个工作日进行结算”。
          所以资金对账请在“工作日”内进行，周末和节假日请勿进行资金核对。<br />
        </div>
        <div class="btn-box" @click="isShowUnionpayPop = false">我知道</div>
      </div>
  </van-popup>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isShowUnionpayPop: true
      }
    },
    
  }
</script>

<style lang="stylus" scoped>
  .content-box {
    padding: 16px;
    .title {
      text-align: center;
      font-size: 17px;
      color: #333333;
      margin-bottom: 18px;
      font-weight: bold;
    }
    .text {
      color: #333333;
      line-height: 20px;
      .text-bottom {
        margin-top: 10px;
      }
    }
    .btn-box {
      height: 38px;
      line-height: 38px;
      text-align: center;
      color: #fff;
      background: linear-gradient( 180deg, #FF8820 0%, #FF6B31 100%);
      border-radius: 4px;
      margin-top: 20px;
      font-weight: bold;
    }
  }
</style>